import React, { useCallback, useEffect, useState } from 'react'
import { Box, Button, TextField } from '@mui/material'

import PlaceService from '@/service/PlaceService'
import DialogHeader from "@/view/layout/DialogHeader"
import HeaderSpacer from "@/view/layout/HeaderSpacer"

export interface PlaceDto {
    id?: number
    teamId?: number
    name: string
}

interface Props {
    onClose: () => void
}

const PlaceView = (props: Props) => {

    const handleOverlayClick = useCallback(
        () => props.onClose(),
        [props.onClose]
    )

    const [places, setPlaces] = useState<PlaceDto[]>([])
    const [selectedPlace, setSelectedPlace] = useState<PlaceDto | null>(null)

    const [name, setName] = useState('')
    const [mode, setMode] = useState<'create' | 'delete'>('create')

    /** 경기장 목록 조회 */
    useEffect(() => {
        loadPlaces()
    }, [])

    const loadPlaces = async () => {
        const list = await PlaceService.getPlaceList()
        setPlaces(list)
    }

    /** 경기장 클릭 */
    const handlePlaceClick = (p: PlaceDto) => {
        setSelectedPlace(p)
        setName(p.name)
        setMode('delete')
    }

    /** 이름 변경 감지 */
    const handleNameChange = (v: string) => {
        setName(v)

        if (selectedPlace && v !== selectedPlace.name) {
            setMode('create')
        }
    }

    /** 버튼 액션 */
    const handleAction = async () => {
        if (mode === 'delete' && selectedPlace?.id) {
            await PlaceService.deletePlace(selectedPlace.id)
        }

        if (mode === 'create') {
            await PlaceService.savePlace({ name })
        }

        resetForm()
        loadPlaces()
    }

    const resetForm = () => {
        setSelectedPlace(null)
        setName('')
        setMode('create')
    }

    /** 버튼 텍스트 */
    const getButtonLabel = () => {
        return mode === 'delete' ? '삭제' : '등록'
    }

    return (
        <>
            <DialogHeader title='경기장 관리' onClose={handleOverlayClick} />

            <div className="place-board">
                <HeaderSpacer />

                {/* PLACE LIST */}
                <Box className="place-list">
                    <h4 className="place-header">
                        전체 ({places.length})
                    </h4>

                    <Box className="place-scroll">
                        {places.map(p => (
                            <Box
                                key={p.id}
                                className="place-row"
                                onClick={() => handlePlaceClick(p)}
                            >
                                <div className="place-line">
                                    <span className="place-name">
                                        {p.name}
                                    </span>
                                </div>
                            </Box>
                        ))}
                    </Box>
                </Box>

                {/* INPUT FORM */}
                <Box sx={{ display: 'flex', gap: 1, mt: 2, justifyContent: 'space-around'}}>
                    <TextField
                        size="small"
                        placeholder="경기장 이름"
                        value={name}
                        onChange={e => handleNameChange(e.target.value)}
                    />

                    <Button
                        sx={{ height: '40px' }}
                        variant="contained"
                        color={mode === 'delete' ? 'error' : 'primary'}
                        onClick={handleAction}
                        disabled={!name}
                    >
                        {getButtonLabel()}
                    </Button>
                </Box>
            </div>
        </>
    )
}

export default PlaceView
